export default __webpack_public_path__ + "static/media/ModalImage1.ad332e00.jpg";